import React from "react";
import { useNavigate } from "react-router-dom";

const HeaderNavigation = () => {
  const navigate = useNavigate();
  return (
    <div className="header-navigation">
      <span
        onClick={() => navigate(-1)}
        role="button"
        className="d-inline-flex align-items-center"
        style={{ cursor: "pointer" }}
      >
        <i className="isax isax-arrow-left me-2"></i>Quay về
      </span>
    </div>
  );
};

export default HeaderNavigation;
